import { useAuth } from '@clerk/clerk-react';
import { useSelector } from '@legendapp/state/react';
import { PublicApiClient, requestIdHeader } from '@tf/api';
import type React from 'react';
import { useEffect } from 'react';

import { configStore } from '@/core/stores';

export const PublicApiClientInitialization: React.FC = () => {
	const config = useSelector(() => configStore.get());
	const { getToken } = useAuth();

	useEffect(() => {
		const fetchWithStatusCheck = async (input: RequestInfo | URL, init?: RequestInit) => {
			const token = await getToken({ template: 'trustform' });
			return await fetch(input, {
				...init,
				headers: {
					...init?.headers,
					...requestIdHeader(),
					Authorization: `Bearer ${token}`,
				},
			});
		};

		PublicApiClient.init(config.urls.api, fetchWithStatusCheck);
	}, [config.urls.api, getToken]);

	return null;
};
